document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ozea-scroll-target]').forEach(function (link) {
    var target = document.getElementById(link.getAttribute('data-ozea-scroll-target'));

    if (!target) {
      link.style.display = 'none';
      return;
    }

    link.addEventListener('click', function () {
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });
});
